import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';

@Component({
  selector: 'app-bar-chart',
  templateUrl: './bar-chart.component.html',
  styleUrls: ['./bar-chart.component.scss']
})
export class BarChartComponent implements OnInit, OnDestroy {

  private chart!: am4charts.XYChart;
  @Input() data: { category: string; value: number }[] = [];

  ngOnInit() {
    this.createChart();
  }

  private createChart(): void {
    // Create chart instance
    this.chart = am4core.create('chartdiv', am4charts.XYChart);

           // Disable amCharts logo
           this.chart.logo.disabled = true;

    // Add data from input or fallback demo
    this.chart.data = (this.data && this.data.length > 0)
      ? this.data
      : [
          { category: 'Approved', value: 0 },
          { category: 'Pending', value: 0 },
          { category: 'Rejected', value: 0 }
        ];

    // Create axes
    const categoryAxis = this.chart.xAxes.push(new am4charts.CategoryAxis());
    categoryAxis.dataFields.category = 'category';

    // Create a title for the category axis
    const categoryAxisTitle = categoryAxis.title;
    categoryAxisTitle.text = 'Categories';

    const valueAxis = this.chart.yAxes.push(new am4charts.ValueAxis());

    // Create a title for the value axis
    const valueAxisTitle = valueAxis.title;
    valueAxisTitle.text = 'Values';

    // Create series
    const series = this.chart.series.push(new am4charts.ColumnSeries());
    series.dataFields.valueY = 'value';
    series.dataFields.categoryX = 'category';
    series.name = 'Values';
    series.columns.template.tooltipText = '{categoryX}: [bold]{valueY}[/]';
    series.columns.template.width = am4core.percent(50); // Set bar width to 50% of the available space
    series.columns.template.fillOpacity = 0.8;

    // Configure category axis labels
    categoryAxis.renderer.labels.template.horizontalCenter = 'middle'; // Center labels horizontally
    categoryAxis.renderer.labels.template.verticalCenter = 'top'; // Position labels at the top
    categoryAxis.renderer.labels.template.dy = 10; // Adjust vertical position

    // Make labels responsive by adjusting font size and rotation
    categoryAxis.renderer.labels.template.fontSize = '12px'; // Default font size
    categoryAxis.renderer.minGridDistance = 20; // Minimum distance between grid lines

    // Adapter to rotate labels on small screens to prevent overlapping
    categoryAxis.renderer.labels.template.adapter.add('rotation', function(rotation, target) {
      if (window.innerWidth < 600) {
        return 45; // Rotate labels by 45 degrees on small screens
      }
      return 0; // No rotation on larger screens
    });

    // Add a cursor to make the chart interactive
    this.chart.cursor = new am4charts.XYCursor();
  }

  ngOnDestroy() {
    if (this.chart) {
      this.chart.dispose();
    }
  }
}
